module.exports = __webpack_public_path__ + "img/about-vip.b8bcd836.png";